import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MatPaginator, MatSort, MAT_DIALOG_DATA } from '@angular/material';
import { ToastrManager } from 'ng6-toastr-notifications';
// import { SignaturePad } from 'angular2-signaturepad/signature-pad';
import { SignaturePad } from 'angular2-signaturepad';
import { TrabajadorService } from '../../../_core/services/trabajador.service';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'm-firma-contrato-dialog',
  templateUrl: './firma-contrato-dialog.component.html',
  styleUrls: ['./firma-contrato-dialog.component.scss']
})
export class FirmaContratoDialogComponent implements OnInit {
  @ViewChild(SignaturePad) signaturePad: SignaturePad;
  signatureString: string = '';
  base64Signature: string = '';
  showFirma = false;

  private signaturePadOptions: Object = { // passed through to szimek/signature_pad constructor
    'minWidth': 2,
    'canvasWidth': 540,
    'canvasHeight': 300
  };

  constructor(
    public dialogRef: MatDialogRef<FirmaContratoDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public toastr: ToastrManager,
    private trabajadorService: TrabajadorService,
    private sanitizer: DomSanitizer,
  ) { }

  ngOnInit() {
    if (this.data.model.Firmado) {
      this.getFirma();
    }
  }

  ngAfterViewInit() {
    // this.signaturePad is now available
    this.signaturePad.set('minWidth', 2); // set szimek/signature_pad options at runtime
    this.signaturePad.clear(); // invoke functions from szimek/signature_pad API
  }

  drawComplete() {
    // will be notified of szimek/signature_pad's onEnd event
    this.signatureString = this.signaturePad.toDataURL();
  }
 
  drawStart() {
    // will be notified of szimek/signature_pad's onBegin event
    console.log('begin drawing');
  }

  getFirma() {
    this.trabajadorService.GetFirma(this.data.model.ImgFirma).subscribe(
      (data: any) => {
        this.base64Signature = "data:image/png;filename=" + this.data.model.ImgFirma + ";base64," + data;
        this.showFirma = true;
      }
    )
  }

  imgSecure() {
    return this.base64Signature;
  }

  save() {
    var data = this.data.model;

    if (this.signatureString == '') {
      if (this.data.model.Firmado) {
        this.toastr.warningToastr('No ha ingresado una nueva firma.', 'Advertencia!', {
          toastTimeout: 2000,
          showCloseButton: true,
          animate: 'fade',
          progressBar: true
        });
      } else {
        this.toastr.warningToastr('Debe ingresar una firma.', 'Advertencia!', {
          toastTimeout: 2000,
          showCloseButton: true,
          animate: 'fade',
          progressBar: true
        });
      }
    } else {
      var model = {
        prmintPostulante: data.Postulante,
        prmstrDNI: data.DNI,
        prmstrDataImgFirma: this.signatureString.replace('data:image/png;base64,', '')
      }

      this.trabajadorService.SaveFirmaPostulante(model).subscribe(
        (data: any) => {
          if (data == 1) {
            this.toastr.successToastr('La firma se registró exitosamente.', 'Éxito', {
              toastTimeout: 2000,
              showCloseButton: true,
              animate: 'fade',
              progressBar: true
            });

            this.dialogRef.close(true);
          }
        }, (error) => {
          this.toastr.errorToastr('Ha ocurrido un error, inténtelo más tarde nuevamente por favor.', 'Error', {
            toastTimeout: 2000,
            showCloseButton: true,
            animate: 'fade',
            progressBar: true
          });
        }
      )
    }
  }

  clear() {
    this.signaturePad.clear();
  }

  clearImgFirma() {
    this.showFirma = false;
  }

  onNoClick(): void {
		this.dialogRef.close();
  }
}
